/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// _ZB_ADMIN_LAST_URL_
// https://www.kessberlin.de/
// _ZB_ADMIN_TIME_STAMP_
// 1606115938651
// _ZB_STATIC_DR_firstTimeVisit
// 1606115762171
// _ZB_STATIC_DR_widgetsUpdateTime
// {"1414476":1605795495,"1453407":1605795899,"1467134":1605796252,"1467439":1605795604,"1474073":1605861245,"1476333":1605796146,"1476972":1605795716,"1477481":1605794821,"1480479":1605796541,"1481531":1605796471,"1482559":1605860176,"1484363":1605794968,"1487000":1605796034,"1489535":1605861382,"1495169":1605861704,"1495786":1605861501,"1499573":1605795160,"1499804":1605860358,"1500492":1605795321,"1501295":1605861033,"1501328":1605782515,"1501365":1605790587,"1501366":1605790817,"1501367":1605790964,"1501368":1605791283,"1501371":1605791665,"1501372":1605791823,"1501373":1605792000,"1501375":1605792216,"1501376":1605792549,"1501378":1605792743,"1501381":1605793309,"1501597":1605860316,"1501621":1605863695,"1501635":1605883534,"1501723":1606114222}
// _ZB_STATIC_LAST_ACCESS_TIME
// 1606116001604
// _ZB_STATIC_SS_DR_currentSessionTimeVisit
// 1606115762171
// _ZB_STATIC_VIEW_THROUGH_WIDGET_1501723
// 1501723
// _ZB_STATS_SS_IMPRESSION.2cf9b135
// true
// _ZB_STATS_SS_IMPRESSION_PREMIUM_
// true
// _ZB_STATS_VISIT_574686
// 1606115966738

if(!Function.prototype.throttle) {
	Function.prototype.throttle = function(delay) {
		const f = this;
		delay = delay || 250;
		let t;
		return function() {
			clearTimeout(t);
			if (!t) { f.apply(this, arguments); }
			t = setTimeout(() => t = null, delay);
		};
	};
}

if(!Function.prototype.debounce) {
	Function.prototype.debounce = function(delay) {
		const f = this;
		delay = delay || 250;
		let t;
		return function() {
			clearTimeout(t);
			t = setTimeout(() => {
				t = null;
				f.apply(this, arguments);
			}, delay);
		};
	};
}

var throttle = function(fn, wait) {
  var time = Date.now();
  return function() {
      if ((time + wait - Date.now()) < 0) {
          fn();
          time = Date.now();
      }
  }
}

var latoriCpb = class {

  constructor(el) {
    this.el = el;
    try { this.data = JSON.parse(this.el.querySelector('[data-cpb-json]').innerText); } catch (error) { this.data = {} }
    this.queryParams = this.searchToObject(window.location.search);
    this.settings = this.getCookieParams();
    this.banners = this.data && Object.keys(this.data).length && this.data.banners.length ? this.data.banners : [];
    this.enableSlider = this.data && this.data.enableSlider ? this.data.enableSlider : false;
    this.sliderSeconds = this.data && this.data.sliderSeconds ? parseInt(this.data.sliderSeconds) : 0;
  }

  searchToObject(search) {
    return search.substring(1).split("&").reduce(function(result, value) {
      var parts = value.split('=');
      if (parts[0]) result[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
      return result;
    }, {});
  }

  init() {
    var _this = this;
    this.validBanners = this.banners.filter(banner => _this.checkBanner(banner));

    if (this.validBanners && this.validBanners.length) {
      if (this.enableSlider && this.validBanners.length > 1) {
        this.initSlider();
      } else {
        this.paintBanner(this.validBanners[0]);
      }
    }
  }

  getCookieParams() {
    return {
      _CPB_LAST_URL_: this.getCookie('_CPB_LAST_URL_') != '' ? this.getCookie('_CPB_LAST_URL_') : null,
      _CPB_LAST_ACCESS_TIME: this.getCookie('_CPB_LAST_ACCESS_TIME') != '' ? this.getCookie('_CPB_LAST_ACCESS_TIME') : null,
      _CPB_FIRST_TIME_VISIT: this.getCookie('_CPB_FIRST_TIME_VISIT') != '' ? this.getCookie('_CPB_FIRST_TIME_VISIT') : null,
      _CPB_ACTIVE_BANNER: this.getCookie('_CPB_ACTIVE_BANNER') != '' ? this.getCookie('_CPB_ACTIVE_BANNER') : null,
      _CPB_SESS_CLOSED_BANNER: this.getCookie('_CPB_SESS_CLOSED_BANNER') != '' ? this.getCookie('_CPB_SESS_CLOSED_BANNER') : null
    }
  }

  setCookieParams() {
    this.setCookie('_CPB_LAST_URL_', window.location.href, 30);
    this.setCookie('_CPB_LAST_ACCESS_TIME', Date.now(), 30);
    if (!this.settings._CPB_FIRST_TIME_VISIT) {
      this.setCookie('_CPB_FIRST_TIME_VISIT', Date.now(), null);
    }
  }

  setCookie(cname, cvalue, exdays) {
    var expires = '';
    if (exdays || exdays != '') {
      var d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      expires = "expires="+d.toUTCString();
    }
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  setCookieHours(cname, cvalue, hours) {
    var expires = '';
    if (hours || hours != '') {
      var d = new Date();
      d.setTime(d.getTime() + (hours * 60 * 60 * 1000));
      expires = "expires="+d.toUTCString();
    }
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  cleanUrlList(urlList) {
    urlList = urlList.map(function(url) {
      // Remove all newlines
      return url.replace( /[\r\n]+/gm, "" );
    });
    urlList = urlList.filter(function(url) {
      // Remove empty keys
      return url != "";
    });
    return urlList;
  }

  checkActiveBanner(banner) {
    var isValid = false;
    if (this.settings && this.settings._CPB_ACTIVE_BANNER && this.settings._CPB_ACTIVE_BANNER === banner.id) {
      isValid = true;
    }
    // X Button was clicked in the session – don't show any buttons even if they are valid
    if (this.settings && this.settings._CPB_SESS_CLOSED_BANNER && this.settings._CPB_SESS_CLOSED_BANNER === banner.id) {
      isValid = false;
    }
    // X Button was clicked once – don't show this button anymore
    var wasClosed = this.getCookie('_CPB_CLOSED_BANNER_' + banner.id) != '' ? this.getCookie('_CPB_CLOSED_BANNER_' + banner.id) : false;
    if (wasClosed) {
      isValid = false;
    }
    return isValid;
  }

  checkBanner(banner) {
    var isValid = true;
    if (banner.hide) {
       return false;
    }
    if (banner.message == '' && (banner.code == '' || banner.link == '')) {
      return false;
    }
    // X Button was clicked in the session
    if (this.settings && this.settings._CPB_SESS_CLOSED_BANNER) {
      return false;
    }
    // X Button was clicked once
    var wasClosed = this.getCookie('_CPB_CLOSED_BANNER_' + banner.id) != '' ? this.getCookie('_CPB_CLOSED_BANNER_' + banner.id) : false;
    if (wasClosed) {
      return false;
    }
    if (banner.visitorType != 'all_visitors') {
      banner.urlTypeValue = this.cleanUrlList(banner.urlTypeValue);
      switch (banner.visitorType) {
        case 'new_visitors_only':
          if (this.settings._CPB_FIRST_TIME_VISIT) {
            return false;
          }
          break;
        case 'returning_visitors_only':
          if (!this.settings._CPB_FIRST_TIME_VISIT) {
            return false;
          }
          break;
        case 'visitors_come_from':
          switch (banner.urlType) {
            case '-':
              return false;
              break;
            case 'urls_containing':
              var hasUrl = banner.urlTypeValue.filter(function(url) {
                return window.location.href.indexOf(url) != -1;
              }).length;
              if (hasUrl === 0) {
                return false;
              }
              break;
            case 'urls_not_containing':
              var hasUrl = banner.urlTypeValue.filter(function(url) {
                return window.location.href.indexOf(url) != -1;
              }).length;
              if (hasUrl === 1) {
                return false;
              }
              break;
          }
          break;
        case 'visitors_dont_come_from':
          switch (banner.urlType) {
            case '-':
              return false;
              break;
            case 'urls_containing':
              var hasUrl = banner.urlTypeValue.filter(function(url) {
                return window.location.href.indexOf(url) != -1;
              }).length;
              if (hasUrl === 1) {
                return false;
              }
              break;
            case 'urls_not_containing':
              var hasUrl = banner.urlTypeValue.filter(function(url) {
                return window.location.href.indexOf(url) != -1;
              }).length;
              if (hasUrl === 0) {
                return false;
              }
              return false;
              break;
          }
          break;
        default:
          break;
      }
    }

    var lastAccessBanner = this.getCookie('_CPB_LAST_ACCESS_BANNER_' + banner.id) != '' ? this.getCookie('_CPB_LAST_ACCESS_BANNER_' + banner.id) : false;
    switch (banner.maxDisplayFrequency) {
      case 'one_page_view':
        if (lastAccessBanner) {
          return false;
        }
        break;
      case 'one_visit_per_hour':
        if (lastAccessBanner && dayjs().diff(dayjs(parseInt(lastAccessBanner)), "hour") == 0) {
          return false;
        }
        break;
      case 'one_visit_per_day':
        if (lastAccessBanner && dayjs().diff(dayjs(parseInt(lastAccessBanner)), "day") == 0) {
          return false;
        }
        break;
      case 'one_visit_per_week':
        if (lastAccessBanner && dayjs().diff(dayjs(parseInt(lastAccessBanner)), "week") == 0) {
          return false;
        }
        break;
      case 'one_visit_per_month':
        if (lastAccessBanner && dayjs().diff(dayjs(parseInt(lastAccessBanner)), "month") == 0) {
          return false;
        }
        break;
      default:
        break;
    }

    if (banner.activateDateTime != '') {
      if (dayjs(banner.activateDateTime, 'YYYY/MM/DD HH:MM').isValid()) {
        if (!dayjs().isAfter(banner.activateDateTime)) {
          return false;
        }
      }
    }

    if (banner.expireDateTime != '') {
      if (dayjs(banner.expireDateTime, 'YYYY/MM/DD HH:MM').isValid()) {
        if (dayjs().isAfter(banner.expireDateTime)) {
          return false;
        }
      }
    }

    switch (banner.showType) {
      case 'show_only_on_homepage':
        if (window.location.pathname != '/') {
          return false;
        }
        break;
      case 'show_on_selected_pages':
        if (banner.onUrlsMatching != '') {
          if (window.location.pathname.match(banner.onUrlsMatching)) {
            isValid = true;
          }
        }
        if (banner.onUrlsContaining != '') {
          banner.onUrlsContaining.split(',').forEach(function(keyword) {
            if (window.location.pathname.match(keyword)) {
              isValid = true;
            }
          });
        }
        if (banner.onUrlsNotMatching != '') {
          if (!window.location.pathname.match(banner.onUrlsNotMatching)) {
            isValid = true;
          }
        }
        break;
      case 'dont_show_on_selected_pages':
        if (banner.onUrlsMatching != '') {
          if (window.location.pathname.match(banner.onUrlsMatching)) {
            isValid = false;
          }
        }
        if (banner.onUrlsContaining != '') {
          banner.onUrlsContaining.split(',').forEach(function(keyword) {
            if (window.location.pathname.match(keyword)) {
              isValid = false;
            }
          });
        }
        if (banner.onUrlsNotMatching != '') {
          if (!window.location.pathname.match(banner.onUrlsNotMatching)) {
            isValid = false;
          }
        }
        break;
    }

    return isValid;
  }

  initSlider() {
    var _this = this;
    // Create a container for the slider
    this.elBannerSlider = document.createElement("div");
    this.elBannerSlider.classList.add('cpb-banner-slider');

    // Set a max height based on the tallest banner
    let maxHeight = Math.max(...this.validBanners.map(banner => banner.height));
    this.elBannerSlider.style.minHeight = maxHeight + 'px';

    // Create Flickity-compatible markup
    this.validBanners.forEach(banner => {
      let slide = this.createBannerSlide(banner);
      this.elBannerSlider.appendChild(slide);
    });

    // Add the slider to the DOM
    this.el.appendChild(this.elBannerSlider);

    // Configure Flickity options
    let flickityOptions = {
      prevNextButtons: this.sliderSeconds > 0 ? false : true,
      pageDots: false,
      wrapAround: true,
      adaptiveHeight: false,
      draggable: true
    };

    // Enable auto-play if slider_seconds is set
    if (this.sliderSeconds > 0) {
      flickityOptions.autoPlay = this.sliderSeconds * 1000;
      flickityOptions.pauseAutoPlayOnHover = true;
    }

    // Initialize Flickity
    this.flickitySlider = new Flickity(this.elBannerSlider, flickityOptions);

    // Adjust page and set cookies
    this.adjustHeaderOffset();

    // Set resize and scroll listeners
    window.addEventListener('resize', throttle(this.adjustHeaderOffset.bind(this), 500));
    document.addEventListener('scroll', throttle(this.onScroll.bind(this), 500));

    // Track banners for cookies
    this.setCookieHours('_CPB_LAST_ACCESS_BANNER_' + this.validBanners[0].id, Date.now(), 1);
    this.setCookieHours('_CPB_ACTIVE_BANNER', this.validBanners[0].id, 1);

    // Add close button functionality
    document.querySelectorAll('[data-cpb-banner-close]').forEach(closeBtn => {
      closeBtn.addEventListener('click', this.closeSlider.bind(this));
    });
  }

  createBannerSlide(banner) {
    var _this = this;
    let slide = document.createElement("div");
    slide.classList.add('cpb-banner', 'cpb-banner-slide');
    slide.setAttribute('data-id', banner.id);
    slide.style.backgroundColor = banner.bgColor;
    slide.style.minHeight = banner.height + 'px';

    // Clone the template for this slide
    slide.innerHTML = this.data.template;

    // Configure the banner content
    let bannerMessage = slide.querySelector('.cpb-banner-message');
    let bannerCodeWrapper = slide.querySelector('.cpb-banner-code-wrapper');
    let bannerCode = slide.querySelector('.cpb-banner-code');

    bannerMessage.style.color = banner.fontColor;
    bannerMessage.innerHTML = banner.message;

    if (banner.messageToUppercase) {
      bannerMessage.classList.add('is-uppercase');
    }

    if (banner.code != '') {
      bannerCode.setAttribute('value', banner.code);
      bannerCode.setAttribute('readonly', '');
      bannerCode.onclick = function() {
        if (!banner.link || banner.link == '') {
          this.select();
          document.execCommand('copy');
          document.getSelection().removeAllRanges();
          _this.showCopyMessage(slide);
        } else {
          window.location.href = banner.link;
        }
      }
    } else {
      bannerCodeWrapper.parentNode.removeChild(bannerCodeWrapper);
    }

    return slide;
  }

  adjustHeaderOffset() {
    if (!this.elBannerSlider) return;

    var sliderHeight = this.elBannerSlider.clientHeight + 'px';
    document.body.style.paddingTop = sliderHeight;
    document.querySelector('#shopify-section-header').style.top = sliderHeight;
    document.documentElement.style.setProperty('--header-banner-height', sliderHeight);
  }

  paintBanner(banner) {
    var _this = this;
    this.elBanner = document.createElement("div");
    this.elBanner.setAttribute('data-id', banner.id);
    this.elBanner.classList.add('cpb-banner');
    this.elBanner.innerHTML = this.data.template;
    this.elBanner.style.backgroundColor = banner.bgColor;
    this.elBanner.style.top = (banner.height * -1) + 'px';
    this.elBanner.style.minHeight = banner.height + 'px';
    this.elBannerMessage = this.elBanner.querySelector('.cpb-banner-message');
    this.elBannerCodeWrapper = this.elBanner.querySelector('.cpb-banner-code-wrapper');
    this.elBannerCode = this.elBanner.querySelector('.cpb-banner-code');
    this.elBannerClose = this.elBanner.querySelector('[data-cpb-banner-close]');
    this.elBannerMessage.style.color = banner.fontColor;
    this.elBannerMessage.innerHTML = banner.message;
    if (banner.messageToUppercase) {
      this.elBannerMessage.classList.add('is-uppercase');
    }
    if (banner.code != '') {
      this.elBannerCode.setAttribute('value', banner.code);
      this.elBannerCode.setAttribute('readonly', '');
      this.elBannerCode.onclick = function() {
        if (!banner.link || banner.link == '') {
          this.select();
          document.execCommand('copy');
          document.getSelection().removeAllRanges();
          _this.showCopyMessage();
        } else {
          window.location.href = banner.link;
        }
      }
    } else {
      this.elBannerCodeWrapper.parentNode.removeChild(this.elBannerCodeWrapper);
    }
    this.el.appendChild(this.elBanner);
    this.elBanner.style.top = 0 + 'px';
    this.setCookieHours('_CPB_LAST_ACCESS_BANNER_' + banner.id, Date.now(), 1);
    this.setCookieHours('_CPB_ACTIVE_BANNER', banner.id, 1);
    window.addEventListener('resize', throttle(this.onResize.bind(this), 500));
    document.addEventListener('scroll', throttle(this.onScroll.bind(this), 500));
    this.elBannerClose.addEventListener('click', this.closeBanner.bind(this));
    this.checkBannerHeight();
  }

  checkBannerHeight() {
    var bannerHeight = this.elBanner.clientHeight + 'px';
    document.body.style.paddingTop = bannerHeight;
    document.querySelector('#shopify-section-header').style.top = bannerHeight;
    document.documentElement.style.setProperty('--header-banner-height', bannerHeight);
  }

  onResize() {
    if (this.enableSlider && this.elBannerSlider) {
      this.adjustHeaderOffset();
      if (this.flickitySlider) {
        this.flickitySlider.resize();
      }
    } else if (this.elBanner) {
      this.checkBannerHeight();
    }
  }

  onScroll() {
    if (this.enableSlider && this.elBannerSlider) {
      this.adjustHeaderOffset();
    } else if (this.elBanner) {
      this.checkBannerHeight();
    }
  }

  showCopyMessage(bannerEl) {
    var _this = this;
    var elCopyMessage = document.createElement("div");
    elCopyMessage.innerText = 'Code kopiert';
    elCopyMessage.classList.add('cpb-copy-message');
    elCopyMessage.style.backgroundColor = '#e91e63';

    if (bannerEl) {
      elCopyMessage.style.top = bannerEl.clientHeight + 'px';
    } else {
      elCopyMessage.style.top = this.elBanner.clientHeight + 'px';
    }

    setTimeout(function() {
      elCopyMessage.style.transform = 'translateY(0)';
    }, 1);
    setTimeout(function() {
      elCopyMessage.style.transform = 'translateY(-100%)';
    }, 1500);
    document.querySelector('#shopify-section-latori-cpb').appendChild(elCopyMessage);
  }

  closeBanner() {
    var id = this.elBanner.getAttribute('data-id');
    this.setCookie('_CPB_SESS_CLOSED_BANNER', id, 0.10);
    this.setCookie('_CPB_CLOSED_BANNER_'+id, Date.now(), 7);
    this.elBanner.parentNode.removeChild(this.elBanner);
    window.removeEventListener('resize', throttle(this.onResize.bind(this), 500));
    document.removeEventListener('scroll', throttle(this.onScroll.bind(this), 500));
    document.documentElement.style.setProperty('--header-banner-height', 0 + 'px');
    document.body.style.paddingTop = 0;
    document.querySelector('#shopify-section-header').style.top = 0;
  }

  closeSlider() {
    if (!this.elBannerSlider) return;

    // Get IDs of all banners
    const bannerIds = Array.from(this.elBannerSlider.querySelectorAll('.cpb-banner-slide')).map(slide =>
      slide.getAttribute('data-id')
    );

    // Set cookies for all banners
    bannerIds.forEach(id => {
      this.setCookie('_CPB_CLOSED_BANNER_'+id, Date.now(), 7);
    });

    // Set session cookie for the active banner
    this.setCookie('_CPB_SESS_CLOSED_BANNER', bannerIds[0], 0.10);

    // Remove the slider
    this.elBannerSlider.parentNode.removeChild(this.elBannerSlider);

    // Reset styles
    document.documentElement.style.setProperty('--header-banner-height', 0 + 'px');
    document.body.style.paddingTop = 0;
    document.querySelector('#shopify-section-header').style.top = 0;

    // Remove listeners
    window.removeEventListener('resize', throttle(this.onResize.bind(this), 500));
    document.removeEventListener('scroll', throttle(this.onScroll.bind(this), 500));

    // Destroy flickity
    if (this.flickitySlider) {
      this.flickitySlider.destroy();
    }
  }
}

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('#shopify-section-latori-cpb').forEach(function(el){
    var elLatoriCpb = new latoriCpb(el);
    elLatoriCpb.init();
  });
});

document.addEventListener('cart:rerendered', async function(e) {
    console.log('[CART DEBUG] ====== First cart:rerendered listener triggered ======');

    // Prevent infinite loops by checking if we're already processing
    if (isProcessingRemoveUpsells) {
      console.log('[CART DEBUG] Already processing remove upsells, skipping first listener...');
      return;
    }

    console.log('[CART DEBUG] Setting isProcessingRemoveUpsells flag to true');
    isProcessingRemoveUpsells = true;

    try {
      let removeList = {};
      document.querySelectorAll('[data-cart-remove-upsell-product]').forEach(el => {
        removeList[el.textContent] = 0;
      });
      console.log('[CART DEBUG] Remove list:', removeList);
      if (Object.keys(removeList).length) {
        console.log('[CART DEBUG] Calling theme.updateCart from first listener');
        const removeResult = await theme.updateCart(removeList);

        // Check if updateCart was successful before dispatching cart:refresh
        if (removeResult && removeResult.status) {
          console.log('[CART DEBUG] First listener updateCart failed - NOT dispatching cart:refresh to prevent loop');
        } else {
          console.log('[CART DEBUG] First listener updateCart succeeded - dispatching cart:refresh');
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
        }
      } else {
        console.log('[CART DEBUG] No items to remove in first listener');
      }
    } catch (error) {
      console.error('[CART DEBUG] Error in first cart:rerendered handler:', error);
    } finally {
      // Reset the flag after processing is complete
      console.log('[CART DEBUG] Scheduling first listener flag reset in 100ms...');
      setTimeout(() => {
        console.log('[CART DEBUG] Resetting isProcessingRemoveUpsells flag to false');
        isProcessingRemoveUpsells = false;
      }, 100);
      console.log('[CART DEBUG] ====== First cart:rerendered listener completed ======');
    }
});

document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; //
  $('.variant-tab-content').hide();
  $('.tabs-' + variant.id).show();
  $('.variant-title').html('<b>' + variant.title + '</b>');

  // Hide all variant media
  $(".Product__SlideItem.Media__Variant").removeClass("Media__Variant__Show");
  $(".Product__SlideItem.Media__Variant").addClass("Media__Variant__Hide");

  $(".Product__SlideshowNavImage.Media__Variant").removeClass("Media__Variant__Show");
  $(".Product__SlideshowNavImage.Media__Variant").addClass("Media__Variant__Hide");

  $(".Product__SlideshowNavImage.Media__Variant").removeClass("is-thumb-selected");
  $(".Product__SlideshowNavImage.Media__Variant").removeClass("is-selected");

  // Show selected variant media
  if(window.innerWidth < 1009) {
    try {
      // First, mark the target slides for the current variant
      var sourceSlides = $(".product_all_media .Media__Variant__" + variant.id);
      sourceSlides.removeClass("Media__Variant__Hide");
      sourceSlides.addClass("Media__Variant__Show");

      // Clear current slides
      var slideshow = $(".Product__Slideshow");
      var allCurrentSlides = $(".Product__Slideshow .Product__SlideItem");

      // More thorough clearing approach
      if (allCurrentSlides.length > 0) {
        slideshow.flickity('remove', allCurrentSlides);
      }

      // Verify clearing worked
      var remainingSlides = $(".Product__Slideshow .Product__SlideItem");

      if (remainingSlides.length > 0) {
        console.warn('📱 Mobile clearing incomplete - forcing manual removal');
        // Fallback: manually remove remaining slides
        slideshow.flickity('destroy');
        slideshow.empty();
        slideshow.flickity({
          "prevNextButtons": false,
          "pageDots": true,
          "adaptiveHeight": true,
          "freeScroll": false,
          "contain": true,
          "wrapAround": true,
          "percentPosition": false,
          "watchCSS": true,
          "draggable": true,
          "dragThreshold": 8,
          "initialIndex": 0
        });
      }

      // Clone variant-specific slides
      var variantSlides = $(".product_all_media .Media__Variant__" + variant.id).clone();

      // Also clone non-variant slides (always visible slides) - skip first one for mobile
      var nonVariantSlides = $(".product_all_media .Product__SlideItem").not('.Media__Variant').slice(1).clone();

      // Combine both sets of slides
      var allSlidesToAdd = variantSlides.add(nonVariantSlides);

      if (allSlidesToAdd && allSlidesToAdd.length) {
        // Ensure proper class application for variant slides
        variantSlides.removeClass("Media__Variant__Hide");
        variantSlides.addClass("Media__Variant__Show");

        // Non-variant slides should already have proper visibility
        nonVariantSlides.addClass("Media__Variant__Show");

        // Append all slides to slideshow
        slideshow.flickity('append', allSlidesToAdd);

        // Force resize and reposition
        slideshow.flickity('resize');

        // Ensure we select the first slide with adequate delay
        setTimeout(function() {
          slideshow.flickity('select', 0, false, true);
        }, 100);
      } else {
        console.warn('No slides found for variant ID: ' + variant.id);
      }
    } catch (e) {
      console.error('Error updating mobile product slideshow:', e);
      // Fallback: Just show the matched slides without flickity manipulation
      $(".Media__Variant__" + variant.id).removeClass("Media__Variant__Hide");
      $(".Media__Variant__" + variant.id).addClass("Media__Variant__Show");
      $(".Product__Slideshow").flickity('resize');
    }
  } else {
    // Desktop behavior
    var desktopSlides = $(".Media__Variant__" + variant.id);
    desktopSlides.removeClass("Media__Variant__Hide");
    desktopSlides.addClass("Media__Variant__Show");

    // For desktop, find the main variant image and select it
    try {
      var variantMainImage = $(".Product__SlideshowNavImage.Media__variant__MainImage.Media__Variant__" + variant.id);
      if (variantMainImage.length) {
        var slidePosition = variantMainImage.attr('data-image-media-position');
        if (slidePosition) {
          $(".Product__Slideshow").flickity('selectCell', parseInt(slidePosition), false, true);
        }
      }
    } catch (e) {
      console.error('Error updating desktop product slideshow:', e);
    }
  }
  $(".Product__Slideshow").flickity('resize');
});

window.upsellAddToCart = function(e) {
  e.preventDefault();
  fetch(window.routes.cartAddUrl + '.js', {
    body: JSON.stringify({
      items: [
        {
          id: parseFloat(e.target.dataset.variantId),
          quantity: 1,
          properties: {
            _upsell_product: e.target.dataset.variantId + ';',
            _upsell_discount_percent: parseFloat(e.target.dataset.discount) + ';',
            _upsell_discount_label: e.target.dataset.discountLabel + ';',
            _upsell_ref_product: e.target.dataset.referenceProduct ? e.target.dataset.referenceProduct + ';' : '',
            _upsell_reference_product_key: e.target.dataset.referenceProductKey ? e.target.dataset.referenceProductKey + ';': '',
            _itemcategory: 'singleproduct;'
          }
        }
      ]
    }),
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  }).then(function (response) {
    if (response.ok) {
      window.closeUpsellDescription(e);
      document.querySelector('#sidebar-cart [data-scrollable]').scrollTo(0,0);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      // document.dispatchEvent(new CustomEvent('product:added', {
      //   bubbles: true,
      //   detail: {
      //     variant: parseFloat(e.target.dataset.variantId),
      //     quantity: 1
      //   }
      // }));
    }
  });
}

if (window.location.search && window.location.search.includes('?cart=open')) {
  document.addEventListener('cart:refresh', function() {
    console.log('[CART DEBUG] cart:refresh listener triggered (cart=open handling)');
    window.openMiniCart(null, {
      onOpen: () => {
        console.log('[CART DEBUG] Mini cart opened via cart:refresh');
      }
    });
  });
}

window.openUpsellDescription = function(e) {
  e.preventDefault();
  var $el = $(e.target);
  var $template = $('#'+$el.data('trigger-upsell-description')).html();
  $('body').append($template);
  const $overlayCurtain = $('<div class="Overlay-Curtain"></div>');
  $overlayCurtain.click(function(e) {
    window.closeUpsellDescription(e);
  });
  $('body').append($overlayCurtain);

  $(document).on('click', '.CartItem__UpsellDescriptionContent .ColorSwatch', function(e) {

    const colorText = $(this).attr('data-color-text');
    const colorVariant = $(this).data('tooltip');
    const variantImagesJSON = $(this).parents('.CartItem__UpsellDescription').data('variant-images-json');
    const $overlayImg = $(this).parents('.CartItem__UpsellDescription').find('figure img');

    if (variantImagesJSON[colorVariant]) {
      console.log($overlayImg);
      $overlayImg.attr('src', variantImagesJSON[colorVariant]);
    }

    if (colorText != '') {
      $(this).parents('.CartItem__UpsellDescriptionContent').find('span.ProductForm__Label .ProductForm__SelectedValue').html($(this).attr('data-tooltip') + ': ' + colorText);
    } else {
      $(this).parents('.CartItem__UpsellDescriptionContent').find('span.ProductForm__Label .ProductForm__SelectedValue').html('');
    }

    $(this).parents('.CartItem__UpsellDescription').find('.CartItem__UpsellCTA button.Upsell__AddToCart').attr('data-variant-id', $(this).attr('data-variant-id'));
  });


  // blend in/out upsell description for choice products
  document.querySelector('.more-infos-button').addEventListener('click', function(e) {
    if (e.target.innerHTML == e.target.dataset.infoText) {
      e.target.innerHTML = e.target.dataset.hideInfoText;
    } else {
      e.target.innerHTML = e.target.dataset.infoText;
    }
    e.target.parentElement.parentElement.querySelector('.more-upsell-info').classList.toggle('show-desc')
  });

  // disable buying sold out variants
  $(document).on('click', '.Overlay.Upsell-Overlay label.ColorSwatch', function() {
    if ($(this).data('soldOut') == true) {
      $(this).parent().parent().parent().siblings('.CartItem__UpsellCTA').find('.Upsell__AddToCart.Button.Button--primary').hide();
      $(this).parent().parent().parent().siblings('.CartItem__UpsellCTA').find('.Upsell__AddToCart.Button.Button--full.Button--secondary').show();
    } else if ($(this).parent().parent().parent().siblings('.CartItem__UpsellCTA').find('.Upsell__AddToCart.Button.Button--primary').css('display') == 'none') {
      $(this).parent().parent().parent().siblings('.CartItem__UpsellCTA').find('.Upsell__AddToCart.Button.Button--full.Button--secondary').hide();
      $(this).parent().parent().parent().siblings('.CartItem__UpsellCTA').find('.Upsell__AddToCart.Button.Button--primary').show();
    }
  });

};

window.closeUpsellDescription = function(e, id) {
  //var $el = $(e.target);
  $('.Overlay').remove();
  $('.Overlay-Curtain').remove();
  if (id) {
    $('.Upsell__AddToCart[data-variant-id="'+id+'"]').click();
  }
};


// https://w3bits.com/javascript-slidetoggle/
let slideUp = (target, duration=500) => {
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.boxSizing = 'border-box';
  target.style.height = target.offsetHeight + 'px';
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout( () => {
    target.style.display = 'none';
    target.style.removeProperty('height');
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
    //alert("!");
  }, duration);
}

let slideDown = (target, duration=500) => {
  target.style.removeProperty('display');
  let display = window.getComputedStyle(target).display;

  if (display === 'none')
    display = 'block';

  target.style.display = display;
  let height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + 'ms';
  target.style.height = height + 'px';
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
  window.setTimeout( () => {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
}
var slideToggle = (target, duration = 500) => {
  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration);
  } else {
    return slideUp(target, duration);
  }
}

window.toggleAccordeon = function(e) {
  let el;
  if (e.currentTarget == e.target) {
    el = e.currentTarget;
  }
  slideToggle(document.querySelector(`[data-acc-content="${el.getAttribute('data-acc-control')}"]`), 200);
  // const $control = $(el);
  // const $content = $control.siblings(`[data-acc-content="${$control.data('acc-control')}"]`);
  // $content.slideToggle('fast');
};

const eventCartUpdate = new Event('cart-update');
const eventItemAdded = new Event('item-added');
const eventAddToCartClicked = new Event('add-to-cart-clicked');
const eventRemoveFromCartClicked = new Event('remove-from-cart-clicked');

theme.onCartUpdate = (cart) => {
    eventCartUpdate.cart = cart;
    document.dispatchEvent(eventCartUpdate);
};

theme.onItemAdded = (cart) => {
    eventItemAdded.cart = cart;
    document.dispatchEvent(eventItemAdded);
};


theme.addToCart = async (items, cb) => {
    console.log('[THEME DEBUG] theme.addToCart called with items:', items);
    let item = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items })
    });
    item = await item.json();
    console.log('[THEME DEBUG] theme.addToCart response:', item);
    if ("function" == typeof cb) {
        console.log('[THEME DEBUG] Calling theme.addToCart callback');
        cb(item);
        console.log('[THEME DEBUG] theme.addToCart callback completed');
    }
    console.log('[THEME DEBUG] theme.addToCart completed');
    return item; // Return the response so caller can check success/failure
};

theme.removeFromCart = async (item, cb) => {
    let response = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ updates: { [item.key]: 0 } })
    });
    response = await response.json();
    if ("function" == typeof cb) {
        cb(response);
    }
};

theme.updateCart = async (updates, cb) => {
    console.log('[THEME DEBUG] theme.updateCart called with updates:', updates);
    let item = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ updates: updates })
    });
    item = await item.json();
    console.log('[THEME DEBUG] theme.updateCart response:', item);
    if ("function" == typeof cb) {
        console.log('[THEME DEBUG] Calling theme.updateCart callback');
        cb(item);
        console.log('[THEME DEBUG] theme.updateCart callback completed');
    }
    console.log('[THEME DEBUG] theme.updateCart completed');
    return item; // Return the response so caller can check success/failure
};

theme.changeQuantity = async (key, qty, cb) => {
    let item = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ updates: { [key]: qty } })
    });
    item = await item.json();
    if ("function" == typeof cb) {
        cb(item);
    }
};

theme.getCart = async (cb) => {
    let cart = await fetch('/cart.json');
    cart = await cart.json();
    if ("function" == typeof cb) {
        cb(cart);
    }
};

theme.clearCart = async (cb) => {
    let res = await fetch('/cart/clear');
    res = await res.json();
    if ("function" == typeof cb) {
        cb(res);
    }
};

// Add flags to prevent infinite loops
let isProcessingUpsells = false;
let isProcessingRemoveUpsells = false;

document.addEventListener('cart:rerendered', async () => {
  console.log('[UPSELL DEBUG] ====== Second cart:rerendered listener triggered ======');

  // Prevent infinite loops by checking if we're already processing
  if (isProcessingUpsells) {
    console.log('[UPSELL DEBUG] Already processing upsells, skipping...');
    return;
  }

  console.log('[UPSELL DEBUG] Setting isProcessingUpsells flag to true');
  isProcessingUpsells = true;

  try {
    let data, updates = {}, addToCartItems = [];
    console.log('[UPSELL DEBUG] Starting upsell processing...');
  let optOutList = JSON.parse(localStorage.getItem('giftOptoutList'));
  if (!Array.isArray(optOutList)) {
    optOutList = [];
  }
  const jsonNode = document.querySelector('[data-upsell-json]');
  try { data = JSON.parse(jsonNode ? jsonNode.textContent : {}); } catch (error) { data = {} }

  const giftIDs = data.map(entry => entry.variant_id);
  const currentCart = await fetch('/cart.js').then(res => res.json());

  for (const item of currentCart.items) {
    const isUpsellGift = item.properties && item.properties._upsell_gift_id === true;
    const notInCurrentUpsell = !giftIDs.includes(item.id);

    if (isUpsellGift && notInCurrentUpsell) {
        updates[item.key] = 0;
    }
  }

  if (data && Object.keys(data).length) {

    data.forEach(level => {
      if (!level.reached && level.product_in_cart) {
        updates[level.product_in_cart] = 0;
      } else if (!level.reached && !level.product_in_cart) {
          removeGiftOptout(optOutList, level.variant_id);
      } else if (level.reached && !level.product_in_cart && !optOutList.includes(level.variant_id)) {
        if (level.variant_id) {
          addToCartItems.push({
            id: level.variant_id,
            quantity: 1,
            properties: {
              _upsell_gift_id: true
            }
          });
        }
      }
    });

    let updateSuccess = true;
    let addSuccess = true;

    if (Object.keys(updates).length) {
      console.log('[UPSELL DEBUG] Calling theme.updateCart with updates:', updates);
      const updateResult = await theme.updateCart(updates);
      console.log('[UPSELL DEBUG] theme.updateCart completed');

      // Check if updateCart was successful
      if (updateResult && updateResult.status) {
        updateSuccess = false;
        console.log('[UPSELL DEBUG] theme.updateCart failed with status:', updateResult.status, updateResult.message);
      } else {
        console.log('[UPSELL DEBUG] theme.updateCart succeeded');
      }
    }

    if (addToCartItems.length) {
      console.log('[UPSELL DEBUG] Calling theme.addToCart with items:', addToCartItems);
      const addResult = await theme.addToCart(addToCartItems);
      console.log('[UPSELL DEBUG] theme.addToCart completed');

      // Check if addToCart was successful (no error status)
      // Successful responses don't have a status property, failed ones have status like 422
      console.log('[UPSELL DEBUG] Checking addResult:', addResult);
      console.log('[UPSELL DEBUG] addResult.status:', addResult?.status);

      if (addResult && addResult.status) {
        addSuccess = false;
        console.log('[UPSELL DEBUG] theme.addToCart failed with status:', addResult.status, addResult.message);
      } else {
        console.log('[UPSELL DEBUG] theme.addToCart succeeded');
      }
    }

    console.log('[UPSELL DEBUG] Final validation - updates.length:', Object.keys(updates).length, 'updateSuccess:', updateSuccess);
    console.log('[UPSELL DEBUG] Final validation - addToCartItems.length:', addToCartItems.length, 'addSuccess:', addSuccess);

    // Only dispatch cart:refresh if operations were successful
    if ((Object.keys(updates).length && updateSuccess) || (addToCartItems.length && addSuccess)) {
      console.log('[UPSELL DEBUG] Operations successful - Dispatching cart:refresh event');
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      console.log('[UPSELL DEBUG] cart:refresh event dispatched');
    } else if (!addSuccess) {
      console.log('[UPSELL DEBUG] addToCart failed - NOT dispatching cart:refresh to prevent loop');
    } else if (!updateSuccess) {
      console.log('[UPSELL DEBUG] updateCart failed - NOT dispatching cart:refresh to prevent loop');
    } else {
      console.log('[UPSELL DEBUG] No cart operations performed, skipping cart:refresh');
    }

  }

  if (document.getElementById('only-upsell-in-cart')) {
    console.log('[UPSELL DEBUG] Processing only-upsell-in-cart section');

    const onlyUpsellIdList = JSON.parse(document.getElementById('only-upsell-in-cart').innerHTML);
    console.log('[UPSELL DEBUG] Only upsell ID list:', onlyUpsellIdList);

    if (onlyUpsellIdList.length) {
      updates = {};
      onlyUpsellIdList.forEach(key => updates[key] = 0);
      console.log('[UPSELL DEBUG] Prepared updates for only-upsell removal:', updates);
    }

    if (Object.keys(updates).length) {
      console.log('[UPSELL DEBUG] Calling theme.updateCart for only-upsell removal');
      const onlyUpsellUpdateResult = await theme.updateCart(updates);

      // Check if updateCart was successful before dispatching cart:refresh
      if (onlyUpsellUpdateResult && onlyUpsellUpdateResult.status) {
        console.log('[UPSELL DEBUG] only-upsell updateCart failed - NOT dispatching cart:refresh to prevent loop');
      } else {
        console.log('[UPSELL DEBUG] only-upsell updateCart succeeded - Dispatching cart:refresh for only-upsell removal');
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        console.log('[UPSELL DEBUG] cart:refresh dispatched for only-upsell removal');
      }
    } else {
      console.log('[UPSELL DEBUG] No only-upsell items to remove');
    }

  } else {
    console.log('[UPSELL DEBUG] No only-upsell-in-cart element found');
  }

  } catch (error) {
    console.error('[UPSELL DEBUG] Error in cart:rerendered handler:', error);
  } finally {
    // Reset the flag after processing is complete
    console.log('[UPSELL DEBUG] Scheduling flag reset in 100ms...');
    setTimeout(() => {
      console.log('[UPSELL DEBUG] Resetting isProcessingUpsells flag to false');
      isProcessingUpsells = false;
    }, 100);
    console.log('[UPSELL DEBUG] ====== Second cart:rerendered listener completed ======');
  }

});

/*
const setMasonryElementHeight = () => {

  let maxHeight = 0;

  document.querySelectorAll('.Grid__Cell .ProductItem').forEach(elProductItem => {
    if (elProductItem.offsetHeight > maxHeight) {
      maxHeight = elProductItem.offsetHeight;
    }
  });

  document.querySelectorAll('.masonry-media-element').forEach(elMasonry => {
    elMasonry.style.maxHeight = `${maxHeight}px`;
  });

}


document.addEventListener("DOMContentLoaded", function() {

  setMasonryElementHeight();
  window.addEventListener('resize', throttle(setMasonryElementHeight, 500));

});
*/

document.addEventListener("DOMContentLoaded", function() {

  document.querySelectorAll('[data-cmp-open]').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      var x = __cmp('consentStatus');
      if(x && x.consentExists) {
        __cmp('showScreenAdvanced');
      }
    });
  });

});



window.addEventListener("load", function() {
  console.log("document is loaded");
  if(document.querySelector('input.product-set__input')){
    var checkedInputs = document.querySelectorAll('input.product-set__input:checked');
    console.log("checkedInputs: ",checkedInputs);
    checkedInputs.forEach(selectedInput => {
      console.log("selectedInput: ",selectedInput);
      var setItem = selectedInput.closest('.configurator__item');
      var originalImageElement = setItem.querySelector('.configurator__Image');
      console.log("setItem: ",setItem);
      if(selectedInput && selectedInput.dataset.colorText != ''){
        setItem.querySelector('.configurator__color-name').innerHTML = selectedInput.dataset.colorName + ':';
        setItem.querySelector('.configurator__color-text').innerHTML = selectedInput.dataset.colorText;
      }else{
        setItem.querySelector('.configurator__color-name').innerHTML = selectedInput.dataset.colorName;
        setItem.querySelector('.configurator__color-text').innerHTML = selectedInput.dataset.colorText;
      }

      console.log("originalImageElement.getAttribute('data-image-id'): ",originalImageElement.getAttribute('data-image-id'));
      console.log("selectedInput.getAttribute('data-image-id'): ",selectedInput.getAttribute('data-image-id'));

      if (selectedInput.hasAttribute('data-image-url')) {
        var newImageElement = document.createElement('img');
        newImageElement.className = 'configurator__Image';
        newImageElement.setAttribute('data-image-id', selectedInput.getAttribute('data-image-id'));
        newImageElement.setAttribute('src', selectedInput.getAttribute('data-image-url'));

        console.log("newImageElement: ",newImageElement);

        originalImageElement.parentNode.style.setProperty('--aspect-ratio', selectedInput.getAttribute('data-image-aspect-ratio'));
        originalImageElement.parentNode.replaceChild(newImageElement, originalImageElement);
      }
    });
  }
});


function runFlickiySlider_productThumbs (slider) {
  // sliders.forEach(slider => {
      console.log("slider:",slider);
      if(slider){
          var flickConfig = JSON.parse(slider.getAttribute('data-flickity-config'));
          console.log("flickConfig:",flickConfig);
          var flkty = new Flickity(slider , flickConfig);
          console.log("flkty: ",flkty);
          var navHeight = document.querySelector(".Product__SlideshowNav--thumbnails").offsetHeight - 10;
          slider.style.width = navHeight + 'px';
          slider.style.display = "block";
          flkty.resize();
          slider.querySelector(".flickity-slider").style.transform = "translateX(0px)";
          document.addEventListener('selectedThumb', function(event) {
            console.log("selectedThumb event", event);
            console.log("details: ", event.detail);
            flkty.selectCell(event.detail.count, false);
            if(event.detail.count == 0){
              console.log("select first slide ");
              slider.querySelector(".flickity-slider").style.transform = "translateX(0px)";
            }
          });

          flkty.on( 'select', function( index ) {
            console.log("select slide num: ", index);
            if(document.querySelector(".Product__SlideshowNavImage").classList.contains('is-selected')){
              console.log("select first slide after selection ");
              slider.querySelector(".flickity-slider").classList.add("custom_translate");
            }else{
              slider.querySelector(".flickity-slider").classList.remove("custom_translate");
            }
          });

          flkty.on( 'settle', function( index ) {
            console.log( 'Flickity settled at ' + index );
          });

          document.addEventListener('variant:changed', function(event) {
            console.log("resize flickity after changing variant: ");
            flkty.resize();
          });
      }
  // });
}

function adjustProductSliderDots(){
  var dots_count = 0,
      first_dot = 0,
      slideshowNavThumbnailsItems = document.querySelectorAll('.Product__SlideshowNavScroller .Product__SlideshowNavImage'),
      sliderDots = document.querySelectorAll('.Product__Slideshow .flickity-page-dots .dot');

  slideshowNavThumbnailsItems.forEach(function (thumbnail) {
    console.log("thumbnail:",thumbnail);
    if (thumbnail.classList.contains('Media__Variant__Hide')) {
      console.log("none of sliderDots[thumbCount]: ",sliderDots[dots_count]);
      sliderDots[dots_count].style.display="none";
    }else{
      console.log("inline of sliderDots[thumbCount]: ",sliderDots[dots_count]);
      sliderDots[dots_count].style.display="inline-block";
      if(first_dot == 0){
        $(".Product__Slideshow").flickity('selectCell', dots_count, true, true );
        $(".Product__Slideshow").flickity('resize');
      }
      first_dot++;
    }
    dots_count++;
  });
}

function runFlickiySlider_dropdown (sliders) {
  sliders.forEach(slider => {
      console.log("slider:",slider);
      if(slider){
          var flickConfig = JSON.parse(slider.getAttribute('data-flickity-config'));
          console.log("flickConfig:",flickConfig);
          var flkty = new Flickity(slider , flickConfig);
          flkty.resize();
          var dropdownSlider = slider.closest(".slider_dopdown_tab");
          console.log("dropdownSlider: ",dropdownSlider);
          dropdownSlider.addEventListener("click", function(){
              console.log("dropdownSlider is clicked: ",dropdownSlider);
              flkty.resize();
          });
      }
  });
}
window.addEventListener("load", function(){
  console.log("run flickity after loading");
  if($('.Product__Slideshow .Media__Variant__Hide').length>0 && window.innerWidth < 1009 ){
    $('.Product__Slideshow .Media__Variant__Hide').remove();
  }
  if(window.innerWidth >= 1009 ){
    var selectedSlide = $('.Product__Slideshow .Media__Variant__Show.Media__variant__MainImage').attr('data-image-media-position');
    $(".Product__Slideshow").flickity('selectCell', parseInt(selectedSlide), false, true );
    // console.log("selectedSlide is", selectedSlide);
  } else {
    // Ensure the first slide is selected on mobile when page loads
    setTimeout(function() {
      try {
        $(".Product__Slideshow").flickity('select', 0, false, true);
      } catch (e) {
        console.error('Error selecting first slide on mobile:', e);
      }
    }, 100);
  }

  $('.Product__Slideshow').flickity('resize');
  var sliders_thumb = document.querySelector('.Carousel-nav');
  runFlickiySlider_productThumbs(sliders_thumb);
  // adjustProductSliderDots();
  var slider_dropdown = document.querySelectorAll('.slider_dropdown');
  runFlickiySlider_dropdown(slider_dropdown);
  if(window.innerWidth >= 1009 ){
    $('.Product__SlideshowNavImage.is-thumb-selected').click();
  }
});

// global functions
// back in stock api
function backInStockApi(email, variantId){
  const formattedDate = '2025-04-15';

  const payload = {
    "data": {
      "type": "back-in-stock-subscription",
      "attributes": {
        "profile": {
          "data": {
              "type": "profile",
              "attributes": {
                  "email": email,
              }
          }
        },
        "channels": ["EMAIL"],
      },
      "relationships": {
        "variant": {
          "data": {
            "type": "catalog-variant",
            "id": `$shopify:::$default:::${variantId}`
          }
        }
      }
    }
  }

  var requestOptions = {
      method: 'POST',
      headers: {"Content-Type": "application/json","Revision": formattedDate},
      body: JSON.stringify(payload),
  };

  fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.theme.klaviyoCompanyId}`,requestOptions)
      .then(result => {
        let successMsg = document.querySelector('.success__msg');
        if(successMsg && result.status == 202)
          successMsg.style.display = 'flex';
      })
      .catch(error => console.log('error: ', error));
}

document.addEventListener('DOMContentLoaded', function() {
  // handle error message
  const btnWrapper = document.querySelector('.sticky_ATC');
  if(btnWrapper){
    btnWrapper.addEventListener('click', (e) => {
      const addToCartButton = btnWrapper.querySelector('.ProductForm__AddToCart');
      const errorWrapper = document.querySelector('.error__wrapper');
      if(addToCartButton
        && addToCartButton.classList.contains('set__products') && errorWrapper){
          errorWrapper.classList.add('is-active');
          errorWrapper.querySelector('span').innerText = errorWrapper.getAttribute('data-error');

      }
      const errorWrapperGift = document.querySelector('.error__wrapper.error__wrapper--gift');
      if(addToCartButton
        && addToCartButton.classList.contains('free-gift__products') && errorWrapperGift){
          const selectGiftText = document.querySelector('[data-free-gift-slider]');
          errorWrapperGift.classList.add('is-active');
          errorWrapperGift.querySelector('span').innerText = selectGiftText.getAttribute('data-select-gift');
      }
    });
  }
  // handle banner header height
  let mainHeaderBanner = document.querySelector('.cpb-banner');
  if(mainHeaderBanner) document.documentElement.style.setProperty('--header-banner-height', mainHeaderBanner.clientHeight + 'px');
});


document.addEventListener('DOMContentLoaded', function() {
  // Initialize filter dropdown functionality
  initFilterDropdown();
});

function initFilterDropdown() {
  const filterContainers = document.querySelectorAll('.filter-dropdown__container');

  filterContainers.forEach(container => {
    const summary = container.querySelector('summary .text');
    const filterItems = container.querySelectorAll('.filter-item');
    const swatchList = container.closest('.ProductForm__Option').querySelector('.ColorSwatchList-flex');

    if (!swatchList) return;

    // Check if there's a preselected variant name
    const preselectedVariantName = swatchList.getAttribute('data-preselected-variant-name');

    // Handle filter item clicks - this is user interaction (not initial load)
    filterItems.forEach(item => {
      item.addEventListener('click', () => {
        const filterValue = item.getAttribute('data-value').toLowerCase();
        const summaryText = item.textContent.trim();

        // Remove active class from all items
        filterItems.forEach(i => i.classList.remove('active'));
        // Add active class to clicked item
        item.classList.add('active');

        // Update summary text and add active class
        summary.textContent = summaryText;
        summary.classList.add('active');

        // Close dropdown
        container.removeAttribute('open');

        // Filter swatches - with false for isInitialLoad (user action)
        filterSwatches(swatchList, filterValue, false);
      });
    });

    // Reset summary active state when dropdown opens/closes
    container.addEventListener('toggle', () => {
      if (!container.hasAttribute('open')) {
        const activeItem = container.querySelector('.filter-item.active');
        summary.classList.toggle('active', activeItem !== null);
      }
    });

    // Apply default filtering on page load - with true for isInitialLoad
    filterSwatches(swatchList, window.variables.all_colors, true, preselectedVariantName);
  });
}

function filterSwatches(swatchList, filterValue, isInitialLoad, preselectedVariantName = null) {
  if (!swatchList || !filterValue) {
    console.error('Missing required parameters');
    return;
  }

  const swatchItems = swatchList.querySelectorAll('.HorizontalList__Item');
  if (!swatchItems.length) {
    console.warn('No swatch items found');
    return;
  }

  // Check if URL has variant parameter
  const hasVariantInUrl = window.location.search.includes('variant=');

  let firstVisibleFound = false;
  let firstVisibleLabel = null;
  let preselectedLabel = null;
  let preselectedIsVisible = false;

  // First pass: determine visibility and find first visible option
  swatchItems.forEach((item) => {
    const label = item.querySelector('label');
    if (!label) return;

    const filterList = label.getAttribute('data-filter-list');
    if (!filterList) {
      // If no filter list, hide the item
      item.classList.add('hidden');
      return;
    }

    const radio = item.querySelector('.ColorSwatch__Radio');

    // Check if this is our preselected variant (only matters during initial load)
    if (isInitialLoad && preselectedVariantName && radio && (radio.value === preselectedVariantName || radio.getAttribute('data-color-name') === preselectedVariantName)) {
      preselectedLabel = label;
    }

    // Check if any value in the filter list matches the filter value exactly
    const filterItems = filterList.split(',').map(item => item.trim().toLowerCase());
    const isMatch = filterItems.includes(filterValue.toLowerCase());

    // Show or hide based on match
    if (isMatch) {
      item.classList.remove('hidden');

      // If this is our preselected variant and it's visible, mark it
      if (preselectedLabel === label) {
        preselectedIsVisible = true;
      }

      // Keep track of first visible item
      if (!firstVisibleFound && radio && !radio.disabled) {
        firstVisibleFound = true;
        firstVisibleLabel = label;
      }
    } else {
      item.classList.add('hidden');
    }
  });

  // Skip auto-selection during initial page load if URL has variant parameter
  if (isInitialLoad && hasVariantInUrl) {
    return; // Don't auto-select any swatch
  }

  // Selection logic - different for initial load vs. user filtering
  if (isInitialLoad && preselectedVariantName && preselectedIsVisible && preselectedLabel) {
    // On initial load, use the preselected variant if available and visible
    setTimeout(() => {
      preselectedLabel.click();
    }, 10);
  } else if (firstVisibleLabel) {
    // Otherwise, select first visible option
    setTimeout(() => {
      firstVisibleLabel.click();
    }, 10);
  }
}

function updateGiftOptout(variant_id) {
  let optOutList = JSON.parse(localStorage.getItem('giftOptoutList'));
  console.log(optOutList);

  if (!Array.isArray(optOutList)) {
    optOutList = [];
  }

  if (!optOutList.includes(variant_id)) {
    optOutList.push(variant_id);
    localStorage.setItem('giftOptoutList', JSON.stringify(optOutList));
  }
}

function removeGiftOptout(optOutList, variant_id) {
  if (!Array.isArray(optOutList)) {
    return [];
  }

  const index = optOutList.indexOf(variant_id);
  if (index !== -1) {
    optOutList.splice(index, 1);
  }

  localStorage.setItem('giftOptoutList', JSON.stringify(optOutList));
}

// Function to update all Stella AI button texts based on analysis state
function updateStellaAiButtonTexts(hasAnalysisData = false) {
  const stellaButtons = document.querySelectorAll('.stella__ai--button');

  stellaButtons.forEach(button => {
    const mainText = button.getAttribute('data-main-text');
    const finalText = button.getAttribute('data-final-text');
    const findationContent = document.querySelector('.findation__content');

    if (hasAnalysisData && finalText) {
      if(findationContent){
        const findationButton = findationContent.querySelector('.button--stella-ai');
        if(findationButton){
          findationButton.textContent = findationButton.getAttribute('data-final-text');
        }
      }else{
        button.textContent = finalText;
      }
    } else if (mainText) {
      button.textContent = mainText;
    }
  });
}

// Check analysis data on page load and update buttons accordingly
function checkAnalysisDataAndUpdateButtons() {
  const analysisData = localStorage.getItem("stellaRecommendedProductVariants");
  const userAnalysisData = localStorage.getItem("stellaAnalysesData");
  const hasAnalysisData = analysisData && userAnalysisData;

  updateStellaAiButtonTexts(hasAnalysisData);
}

// Listen for storage events to update button texts when localStorage is modified from other tabs or programmatically
window.addEventListener('storage', function(e) {
  if (e.key === 'stellaRecommendedProductVariants' || e.key === 'stellaAnalysesData') {
    checkAnalysisDataAndUpdateButtons();
  }
});

['stella-analysis-finished', 'DOMContentLoaded'].forEach(event => {
  document.addEventListener(event, (e) => {
    // Update button texts based on analysis state
    checkAnalysisDataAndUpdateButtons();

    const stellaAiResultsTemplate = document.querySelector("#stella-ai-results-template");
    const stellaPopupContainer = document.querySelector(".stella__iframe--container .Container");
    const analysisData = localStorage.getItem("stellaRecommendedProductVariants");
    const userAnalysisData = localStorage.getItem("stellaAnalysesData");
    const variantDataScript = document.querySelector("#stella-ai-variant-data");
    const oldResults = stellaPopupContainer.querySelector('.stella__iframe');

    if(!stellaAiResultsTemplate || !stellaPopupContainer || !analysisData || !variantDataScript || !userAnalysisData) {
      return;
    }

    let stellaVariantData;
    try {
      stellaVariantData = JSON.parse(variantDataScript.textContent);
    } catch (error) {
      return;
    }

    if (oldResults) {
      oldResults.classList.add('hidden');
    }
    const stellaAiResultsContainer = stellaAiResultsTemplate.content;
    const stellaAiTemplate = document.importNode(stellaAiResultsContainer, true);

    processAnalysisDataWithJsonData(analysisData, stellaAiTemplate, stellaPopupContainer, stellaVariantData, userAnalysisData, e.type);
  });
});


async function processAnalysisDataWithJsonData(analysisData, stellaAiTemplate, stellaPopupContainer, stellaVariantData, userAnalysisData, eventType) {
  cleanupPreviousStellaAiIndicators();
  showLoadingSpinner(stellaPopupContainer);

  // Only save the current product URL when the analysis is actually finished (not on page load)
  if (eventType === 'stella-analysis-finished') {
    localStorage.setItem('stellaAnalysisProductUrl', window.location.pathname);
  }

  try {
    const parsedAnalysisData = JSON.parse(analysisData);
    const parsedUserAnalysisData = JSON.parse(userAnalysisData);

    // Convert new format to match old structure
    const analysisResult = {
      name: parsedUserAnalysisData[0]?.first_name?.trim() || "Your perfect match",
      products: parsedAnalysisData.map(item => ({
        variant_id: item.variant_id,
        link: "", // We'll match by variant ID only
        color_name: "" // We'll get this from the variant data
      }))
    };

    const result = await updateStellaAiResultsWithJsonData([analysisResult], stellaAiTemplate, stellaVariantData);

    if (result.hasMatches) {
      // We found matching variants, show Stella results
      if (result.colorNames && result.colorNames.length > 0) {
        updateSubheadlineWithColors(stellaAiTemplate, result.colorNames, analysisResult.name);
      }
      showStellaResults(stellaPopupContainer, stellaAiTemplate);
      // Update button texts to show final text (analysis completed)
      updateStellaAiButtonTexts(true);
    } else {
      // No matching variants found, show oldResults (iframe)
      showOldResults(stellaPopupContainer);
      // Update button texts to show final text (analysis completed)
      updateStellaAiButtonTexts(true);
    }

  } catch (error) {
    stellaPopupContainer.innerHTML = '<div style="padding: 40px; text-align: center;">Error processing results</div>';
  }
}

// Function to show oldResults (iframe) instead of Stella results
function showOldResults(container) {
  const oldResults = container.querySelector('.stella__iframe');
  const loadingContainer = container.querySelector('.stella__loading--container');

  if (loadingContainer) loadingContainer.remove();

  if (oldResults) {
    oldResults.classList.remove('hidden');
  }
}

// Track which product elements have been updated
const updatedProductElements = new Set();

async function updateStellaAiResultsWithJsonData(analysisProducts, template, stellaVariantData) {
  const resultsContainer = template.querySelector('.stella__ai--results--products');
  const mainProductHandle = resultsContainer.getAttribute('data-main-product-handle');
  const orderedColorNames = [];
  const usedVariantIds = new Set();
  let hasSuccessfulMatches = false;

  createProductElementsFromJson(stellaVariantData, resultsContainer);

  const displayedProducts = stellaVariantData.relatedProducts && stellaVariantData.relatedProducts.length > 0
    ? stellaVariantData.relatedProducts
    : [stellaVariantData.currentProduct];

  // Clear the set at the start of each update
  updatedProductElements.clear();

  for (const displayedProduct of displayedProducts) {
    // Get all product elements with this handle
    const productElements = resultsContainer.querySelectorAll(`[data-handle="${displayedProduct.handle}"]`);
    // Find the first unused product element
    let productElement = Array.from(productElements).find(el => !updatedProductElements.has(el));

    if (!productElement) {
      continue;
    }

    updatedProductElements.add(productElement);

    let hasMatchForThisProduct = false;

    if (displayedProduct.type === 'SET') {
      const setColorNames = await processSetProductColors(displayedProduct, productElement, mainProductHandle, stellaVariantData, analysisProducts[0].products, usedVariantIds);
      if (setColorNames && setColorNames.length > 0) {
        orderedColorNames.push(...setColorNames);
        hasSuccessfulMatches = true;
        hasMatchForThisProduct = true;
      }
    } else {
      // Find first available matching variant (allow same variant to be used for multiple product elements)
      const matchingVariant = analysisProducts[0].products.find(ap => {
        return displayedProduct.variants.some(v => v.id.toString() === ap.variant_id.toString() && v.available);
      });

      if (matchingVariant) {
        const variant = displayedProduct.variants.find(v => v.id.toString() === matchingVariant.variant_id.toString());
        if (variant) {
          await updateProductColorInfoWithJson(productElement, variant.id, displayedProduct.handle, mainProductHandle, stellaVariantData);
          const colorName = variant.colorName || variant.title;
          if (colorName) {
            orderedColorNames.push(colorName);
          }
          hasSuccessfulMatches = true;
          hasMatchForThisProduct = true;
        }
      }
    }

    // Hide product element if no matching color was found
    if (!hasMatchForThisProduct) {
      productElement.style.display = 'none';
    }
  }

  return { colorNames: orderedColorNames, hasMatches: hasSuccessfulMatches };
}

async function processSetProductColors(displayedProduct, productElement, mainProductHandle, stellaVariantData, analysisProducts, usedVariantIds) {
  const setColorNames = [];

  const setProduct = stellaVariantData.relatedProducts?.find(p => p.type === 'SET') ||
                     (stellaVariantData.currentProduct?.type === 'SET' ? stellaVariantData.currentProduct : null);

  if (!setProduct?.setProducts) return setColorNames;

  const setProductTypes = Object.keys(setProduct.setProducts);
  let processedTypes = 0;

  for (const productType of setProductTypes) {
    if (processedTypes >= 2) break; // Process only 2 types maximum

    const productTypeData = setProduct.setProducts[productType];
    if (!productTypeData?.variants) continue;

    // Find first available matching variant for this type (allow same variant to be used for multiple product elements)
    const matchingVariant = analysisProducts.find(ap => {
      return productTypeData.variants.some(v => v.id.toString() === ap.variant_id.toString() && v.available);
    });

    if (matchingVariant) {
      const variant = productTypeData.variants.find(v => v.id.toString() === matchingVariant.variant_id.toString() && v.available);
      if (variant) {
        await updateSetProductColorInfoWithJson(
          productElement,
          variant.id,
          displayedProduct.handle,
          mainProductHandle,
          stellaVariantData,
          productType
        );

        processedTypes++;

        const colorName = variant.colorName || variant.title;
        if (colorName) {
          setColorNames.push(colorName);
        }
      }
    }
  }

  return setColorNames;
}

// Helper function to update subheadline with collected color names - now with capitalization
function updateSubheadlineWithColors(stellaAiTemplate, colorNames, name) {
  const subheadlineElement = stellaAiTemplate.querySelector('.stella__ai--results--header--subheadline p');
  const headlineElement = stellaAiTemplate.querySelector('.stella__ai--results--header h2');

  // Remove duplicates first, then capitalize all color names
  const uniqueColorNames = [...new Set(colorNames)];
  const capitalizedColorNames = uniqueColorNames.map(colorName => {
    // Handle multi-word color names properly
    return colorName.split(' ').map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(' ');
  });
  // Format colors for display
  let formattedColors;
  if (capitalizedColorNames.length === 1) {
    formattedColors = capitalizedColorNames[0];
  } else if (capitalizedColorNames.length === 2) {
    formattedColors = capitalizedColorNames.join(' & ');
  } else {
    formattedColors = capitalizedColorNames.slice(0, -1).join(', ') + ' & ' + capitalizedColorNames[capitalizedColorNames.length - 1];
  }


  if (subheadlineElement) {
    let updatedText = subheadlineElement.textContent;

    if (updatedText.includes('[recommended shade]')) {
      updatedText = updatedText.replace(/\[recommended shade\]/g, `"${formattedColors}"`);
    }
    if (updatedText.includes('[name]')) {
      updatedText = updatedText.replace(/\[name\]/g, name);
    }
    subheadlineElement.textContent = updatedText;
  }

  if (headlineElement) {
    let updatedText = headlineElement.textContent;

    if (updatedText.includes('[recommended shade]')) {
      updatedText = updatedText.replace(/\[recommended shade\]/g, `"${formattedColors}"`);
    }
    if (updatedText.includes('[name]')) {
      updatedText = updatedText.replace(/\[name\]/g, name);
    }
    headlineElement.textContent = updatedText;
  }
}

// Function to create product elements dynamically from JSON data
function createProductElementsFromJson(stellaVariantData, container) {
  // Clear existing content
  container.innerHTML = '';

  const { currentProduct, relatedProducts } = stellaVariantData;

  // If we have related products, use only those
  if (relatedProducts && relatedProducts.length > 0) {
    // Deduplicate products by handle to avoid creating duplicate DOM elements
    const uniqueProducts = relatedProducts.reduce((acc, product) => {
      const existingProduct = acc.find(p => p.handle === product.handle);
      if (!existingProduct) {
        acc.push(product);
      }
      return acc;
    }, []);

    uniqueProducts.forEach(product => {
      const productElement = createSingleProductElement(product);
      container.appendChild(productElement);
    });

  } else {
    // No related products, use current product
    const currentProductElement = createSingleProductElement(currentProduct);
    container.appendChild(currentProductElement);
  }
}

// Function to create a single product element
function createSingleProductElement(product) {
  const productDiv = document.createElement('div');
  productDiv.className = 'stella__ai--results--product';
  productDiv.setAttribute('data-handle', product.handle);

  // Create product image
  const img = document.createElement('img');
  img.src = product.featuredImage || '/placeholder-image.jpg';
  img.alt = product.title;
  img.width = 160;
  img.height = 157;

  // Create product title
  const titleSpan = document.createElement('span');
  titleSpan.textContent = product.title;
  titleSpan.classList.add('stella__ai--results--product--title');
  // // Create product price
  // const priceSpan = document.createElement('span');
  // priceSpan.textContent = product.price || 0;

  // Create color elements based on product type
  let colorElements;
  if (product.type === 'SET') {
    // SET products have multiple colors
    const colorsDiv = document.createElement('div');
    colorsDiv.className = 'stella__ai--results--product--colors';

    const color1 = document.createElement('span');
    color1.className = 'stella__ai--results--product--color';
    color1.setAttribute('data-index', '0');

    const color2 = document.createElement('span');
    color2.className = 'stella__ai--results--product--color';
    color2.setAttribute('data-index', '1');

    colorsDiv.appendChild(color1);
    colorsDiv.appendChild(color2);

    const colorTextDiv = document.createElement('div');
    colorTextDiv.className = 'stella__ai--results--product--color--text stella__ai--results--product--colors--text';
    colorTextDiv.innerHTML = `${product.colors_text}: <span class="stella__ai--results--product--color--value"></span>`;

    colorElements = [colorsDiv, colorTextDiv];
  } else {
    // SINGLE/MONO products have one color
    const colorSpan = document.createElement('span');
    colorSpan.className = 'stella__ai--results--product--color';

    const colorTextDiv = document.createElement('div');
    colorTextDiv.className = 'stella__ai--results--product--color--text';
    colorTextDiv.innerHTML = `${product.color_text}: <span class="stella__ai--results--product--color--value"></span>`;

    colorElements = [colorSpan, colorTextDiv];
  }

  // Append all elements
  productDiv.appendChild(img);
  productDiv.appendChild(titleSpan);
  // productDiv.appendChild(priceSpan);
  colorElements.forEach(element => productDiv.appendChild(element));

  return productDiv;
}
// Function to add Stella AI tooltip and infinity icon to ColorSwatch
function addStellaAiIndicators(colorSwatchLabel) {
  // Check if indicators already exist
  const existingTooltip = colorSwatchLabel.querySelector('.stella-ai--tooltip--container');
  const existingInfinity = colorSwatchLabel.querySelector('.stella-ai--infinity--container');

  if (existingTooltip || existingInfinity) return;

  // Get templates
  const tooltipTemplate = document.getElementById('stella-ai-tooltip-template');
  const infinityTemplate = document.getElementById('stella-ai-infinity-template');

  if (tooltipTemplate && infinityTemplate) {
    // Clone and append tooltip
    const tooltipClone = tooltipTemplate.content.cloneNode(true);
    colorSwatchLabel.appendChild(tooltipClone);
    // Clone and append infinity icon
    const infinityClone = infinityTemplate.content.cloneNode(true);
    colorSwatchLabel.appendChild(infinityClone);
    // Mark this swatch as processed
    colorSwatchLabel.dataset.stellaAiProcessed = 'true';
  } else {
    console.error("❌ Could not find Stella AI templates");
  }
}

function updateColorElements(productElement, colorInfo) {
  const colorSpans = productElement.querySelectorAll('.stella__ai--results--product--color');

  if (colorSpans.length > 0) {
    // For single products, update the first color span
    if (colorInfo.hexColor) {
      const colorInfoArray = colorInfo.hexColor.split(',');

      // Helper function to check if a string is a valid hex color
      const isValidHex = (color) => {
        let trimmedColor = color.trim();

        // If it starts with # and has more than 7 characters total (# + 6 hex chars)
        if (trimmedColor.startsWith('#') && trimmedColor.length > 7) {
          trimmedColor = trimmedColor.substring(0, 7); // Keep # + first 6 characters
        }

        const isValid = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(trimmedColor);
        return isValid;
      };

      if (colorInfoArray.length > 1) {
        // Process colors to handle truncation for gradient generation
        const processedColors = colorInfoArray.map(color => {
          let trimmedColor = color.trim();
          if (trimmedColor.startsWith('#') && trimmedColor.length > 7) {
            trimmedColor = trimmedColor.substring(0, 7);
          }
          return trimmedColor;
        });

        const allHexColors = colorInfoArray.every(color => isValidHex(color));
        if (allHexColors) {
          // Generate conic gradient with percentage stops using processed colors
          const gradientStops = [];
          const segmentSize = 100 / processedColors.length;

          processedColors.forEach((color, index) => {
            const startPercent = index * segmentSize;
            const endPercent = index === processedColors.length - 1 ? 99 : (index + 1) * segmentSize;

            gradientStops.push(`${color} ${startPercent}%`);
            gradientStops.push(`${color} ${endPercent}%`);
          });

          const background = `conic-gradient(${gradientStops.join(',')})`;
          colorSpans[0].style.background = background;
        } else {
          // Contains non-hex colors, use colorSwatchImage if available
          if (colorInfo.colorSwatchImage) {
            colorSpans[0].style.backgroundImage = `url(${colorInfo.colorSwatchImage})`;
            colorSpans[0].style.backgroundSize = 'cover';
            colorSpans[0].style.backgroundPosition = 'center';
            colorSpans[0].style.backgroundRepeat = 'no-repeat';
          }
        }
      } else {
        // Single color - check if it's a hex code
        if (isValidHex(colorInfo.hexColor)) {
          // Process single color to handle truncation
          let processedColor = colorInfo.hexColor.trim();
          if (processedColor.startsWith('#') && processedColor.length > 7) {
            processedColor = processedColor.substring(0, 7);
          }
          colorSpans[0].style.backgroundColor = processedColor;
        } else {
          // Not a hex color (e.g., "slip"), use colorSwatchImage if available
          if (colorInfo.colorSwatchImage) {
            colorSpans[0].style.backgroundImage = `url(${colorInfo.colorSwatchImage})`;
            colorSpans[0].style.backgroundSize = 'cover';
            colorSpans[0].style.backgroundPosition = 'center';
            colorSpans[0].style.backgroundRepeat = 'no-repeat';
          }
        }
      }
    }
  }
}

// Helper function to update color value elements (unchanged)
function updateColorValueElements(productElement, colorName) {
  const colorValueElement = productElement.querySelector('.stella__ai--results--product--color--value');

  if (colorValueElement && colorName) {
    colorValueElement.textContent = colorName;
  }
}

// Function to enable SET ATC button (unchanged)
function enableSetAtcButton() {
  const atcBtn = document.querySelector('.ProductForm__AddToCart');
  const doneBtn = document.querySelector('.set__selected');
  const errorWrapper = document.querySelector('.error__wrapper');

  if (atcBtn) {
    atcBtn.removeAttribute('disabled');
    atcBtn.classList.remove('set__products');
  }

  if (doneBtn) {
    doneBtn.style.display = 'block';
  }

  if (errorWrapper) {
    errorWrapper.classList.remove('is-active');
  }
}

// Function to find variant data in JSON structure
function findVariantDataInJson(variantId, handle, stellaVariantData) {
  // If we have related products, prioritize them over current product
  if (stellaVariantData.relatedProducts && stellaVariantData.relatedProducts.length > 0) {
    // Search in related products first
    for (const product of stellaVariantData.relatedProducts) {
      // For SET products, search dynamically in all setProducts types
      if (product.type === 'SET' && product.setProducts) {
        // Get all product types in the SET dynamically
        const setProductTypes = Object.keys(product.setProducts);
        // Search in each product type dynamically
        for (const productType of setProductTypes) {
          const productTypeData = product.setProducts[productType];

          if (productTypeData && productTypeData.variants) {
            const foundVariant = productTypeData.variants.find(v =>
              v.id.toString() === variantId.toString() ||
              v.handle === handle ||
              (v.colorName && v.colorName.toLowerCase().replace(/\s+/g, '-') === handle)
            );

            if (foundVariant) {
              return {
                variant: foundVariant,
                productData: product,
                setProductType: productType,
                isSetProduct: true
              };
            }
          }
        }
      }

      // Then search regular variants
      const variantData = product.variants.find(v => v.id.toString() === variantId.toString());
      if (variantData) {
        return { variant: variantData, productData: product };
      }
    }
  } else {
    // Only search current product if no related products exist
    const currentProduct = stellaVariantData.currentProduct;
    // For SET products, search dynamically in all setProducts types
    if (currentProduct.type === 'SET' && currentProduct.setProducts) {
      // Get all product types in the SET dynamically
      const setProductTypes = Object.keys(currentProduct.setProducts);
      // Search in each product type dynamically
      for (const productType of setProductTypes) {
        const productTypeData = currentProduct.setProducts[productType];

        if (productTypeData && productTypeData.variants) {
          const foundVariant = productTypeData.variants.find(v =>
            v.id.toString() === variantId.toString() ||
            v.handle === handle ||
            (v.colorName && v.colorName.toLowerCase().replace(/\s+/g, '-') === handle)
          );

          if (foundVariant) {
            return {
              variant: foundVariant,
              productData: currentProduct,
              setProductType: productType,
              isSetProduct: true
            };
          }
        }
      }
    }
    // Then search current product regular variants
    const variantData = currentProduct.variants.find(v => v.id.toString() === variantId.toString());
    if (variantData) {
      return { variant: variantData, productData: currentProduct };
    }
  }
  // Search all products for variants that match the handle
  const allProducts = stellaVariantData.relatedProducts && stellaVariantData.relatedProducts.length > 0
    ? stellaVariantData.relatedProducts
    : [stellaVariantData.currentProduct];

  for (const product of allProducts) {
    // For SET products, search dynamically in all setProducts types by handle
    if (product.type === 'SET' && product.setProducts) {
      // Get all product types in the SET dynamically
      const setProductTypes = Object.keys(product.setProducts);

      // Search in each product type by handle
      for (const productType of setProductTypes) {
        const productTypeData = product.setProducts[productType];

        if (productTypeData && productTypeData.variants) {
          const foundVariant = productTypeData.variants.find(v =>
            v.handle === handle ||
            (v.colorName && v.colorName.toLowerCase().replace(/\s+/g, '-') === handle)
          );

          if (foundVariant) {
            return {
              variant: foundVariant,
              productData: product,
              setProductType: productType,
              isSetProduct: true
            };
          }
        }
      }
    }

    // Check regular variants
    for (const variant of product.variants) {
      if (variant.handle === handle || (variant.colorName && variant.colorName.toLowerCase().replace(/\s+/g, '-') === handle)) {
        return { variant: variant, productData: product };
      }
    }
  }

  return null;
}

async function updateProductColorInfoWithJson(productElement, variantId, handle, mainProductHandle, stellaVariantData) {
  const variantResult = findVariantDataInJson(variantId, handle, stellaVariantData);

  if (!variantResult) {
    return;
  }

  const { variant: variantData, productData } = variantResult;

  // Always search globally for ALL matching color swatches on the page
  const globalSelectors = [
    `input[value="${variantId}"] + label.ColorSwatch`,
    `input[data-variant-id="${variantId}"] + label.ColorSwatch`,
    `input[value="${variantData.colorName}"] + label.ColorSwatch`
  ];

  const allMatchingSwatches = [];
  for (const selector of globalSelectors) {
    const swatches = document.querySelectorAll(selector);
    swatches.forEach(swatch => {
      if (!allMatchingSwatches.includes(swatch)) {
        allMatchingSwatches.push(swatch);
      }
    });
  }

  // Apply updates to ALL matching swatches
  if (allMatchingSwatches.length > 0) {
    allMatchingSwatches.forEach((swatch, index) => {
      applyColorUpdates(swatch, variantData, productElement, variantId, mainProductHandle);
    });
    return; // Successfully updated swatches
  }

  return;
}

// Store recommended swatches to click later
window.stellaRecommendedSwatches = window.stellaRecommendedSwatches || [];
// Store SET-specific swatches with their setup functions (separate from normal swatches)
window.stellaSetSwatches = window.stellaSetSwatches || [];

// Helper function to apply color updates
function applyColorUpdates(colorSwatchElement, variantData, productElement, variantId, mainProductHandle) {
  // Update the color swatch
  if (variantData.hexColor) {
    colorSwatchElement.style.backgroundColor = variantData.hexColor;
  }

  // Update Stella results color display
  updateColorElements(productElement, {
    hexColor: variantData.hexColor,
    colorName: variantData.colorName,
    colorText: '',
    colorSwatchImage: variantData.colorSwatchImage
  });

  // Update color value text
  updateColorValueElements(productElement, variantData.colorName);
  // Add Stella AI indicators
  addStellaAiIndicators(colorSwatchElement);

  // Store the swatch for later clicking instead of clicking immediately (avoid duplicates)
  if (!window.stellaRecommendedSwatches.includes(colorSwatchElement)) {
    window.stellaRecommendedSwatches.push(colorSwatchElement);
  }
}

// New function to update SET product color info using JSON data
async function updateSetProductColorInfoWithJson(productElement, variantId, handle, mainProductHandle, stellaVariantData, productType, analysisData = null) {
  // Find the variant data in SET products
  const setProduct = stellaVariantData.relatedProducts?.find(p => p.type === 'SET') ||
                     (stellaVariantData.currentProduct?.type === 'SET' ? stellaVariantData.currentProduct : null);

  if (!setProduct?.setProducts?.[productType]?.variants) {
    return;
  }

  const variantData = setProduct.setProducts[productType].variants.find(v => v.id.toString() === variantId.toString());

  if (!variantData) {
    return;
  }

  // Get the current number of colors already processed to determine the index
  const existingColors = productElement.querySelectorAll('.stella__ai--results--product--color[style*="background-color"]');
  const colorIndex = existingColors.length;

  // Update Stella results color span
  const colorSpan = productElement.querySelector(`.stella__ai--results--product--color[data-index="${colorIndex}"]`);
  if (colorSpan && variantData.hexColor) {
    colorSpan.style.backgroundColor = variantData.hexColor;
  }

  // Update the color value text for SET products
  const colorValueSpan = productElement.querySelector('.stella__ai--results--product--color--value');
  if (colorValueSpan) {
    const currentText = colorValueSpan.textContent || '';
    const newColorName = variantData.colorName || variantData.title;

    if (colorIndex === 0) {
      // First color
      colorValueSpan.textContent = newColorName;
    } else {
      // Additional colors - append with separator
      const separator = currentText ? ' + ' : '';
      colorValueSpan.textContent = currentText + separator + newColorName;
    }
  }

  // update set popup color info
  const setShades = document.querySelectorAll('.Shadefinder_container--set .set__first--shade, .Shadefinder_container--set .set__second--shade');
  let footerShades = document.querySelectorAll('.set__footer .set__first--shade, .set__footer .set__second--shade');

  if (setShades[colorIndex]){
    setShades.forEach(shade => {
      shade.classList.remove('is-active');
    });
    footerShades.forEach(shade => {
      shade.classList.remove('is-active');
    });

    const setShade = setShades[colorIndex];
    setShade.classList.add('is-active');
    if(footerShades[colorIndex]) {
      footerShades[colorIndex].classList.add('is-active');
    }

    const setPopupItems = document.querySelectorAll('.set-items__wrapper');
    setPopupItems.forEach((item, itemIndex) => {
      const colorSwatch = item.querySelector('.ColorSwatch[data-variant-id="' + variantData.id + '"]');

      if (colorSwatch) {
          addStellaAiIndicators(colorSwatch);

          // Store the SET-specific setup function to run before clicking this swatch
          const setupFunction = () => {
            // Re-run the shade activation logic when the swatch is actually clicked
            const currentSetShades = document.querySelectorAll('.Shadefinder_container--set .set__first--shade, .Shadefinder_container--set .set__second--shade');
            const currentFooterShades = document.querySelectorAll('.set__footer .set__first--shade, .set__footer .set__second--shade');

            if (currentSetShades[colorIndex]) {
              currentSetShades.forEach((shade, shadeIndex) => {
                shade.classList.remove('is-active');
              });
              currentFooterShades.forEach((shade, shadeIndex) => {
                shade.classList.remove('is-active');
              });

              const setShade = currentSetShades[colorIndex];
              setShade.classList.add('is-active');

              if(currentFooterShades[colorIndex]) {
                currentFooterShades[colorIndex].classList.add('is-active');
              }

              if(colorIndex > 0){
                enableSetAtcButton();
              }
            }
          };
          // Check if this SET swatch is already stored to avoid duplicates
          const existingSetSwatch = window.stellaSetSwatches.find(item => item.swatch === colorSwatch);
          if (!existingSetSwatch) {
            window.stellaSetSwatches.push({
              swatch: colorSwatch,
              setup: setupFunction,
              postClick: () => addStellaAiIndicatorsToSetSvg(variantData.id, colorIndex, true)
            });
          }
        }
    });
  }
  addStellaAiIndicatorsToSetSvg(variantData.id, colorIndex);
}

// Function to clean up previous Stella AI indicators
function cleanupPreviousStellaAiIndicators() {
  const colorSwatches = document.querySelectorAll('.ColorSwatch');

  colorSwatches.forEach(swatch => {
    // Remove tooltip containers
    const tooltipContainers = swatch.querySelectorAll('.stella-ai--tooltip--container');
    tooltipContainers.forEach(container => container.remove());

    // Remove infinity containers
    const infinityContainers = swatch.querySelectorAll('.stella-ai--infinity--container');
    infinityContainers.forEach(container => container.remove());

    // Remove enhanced class and processing tracking
    swatch.classList.remove('stella-ai-enhanced');
    if (swatch.dataset.stellaAiProcessed) {
      delete swatch.dataset.stellaAiProcessed;
    }
  });

  // Clear stored recommended swatches and SET swatches
  window.stellaRecommendedSwatches = [];
  window.stellaSetSwatches = [];
}

function addStellaAiIndicatorsToSetSvg(variantId, colorIndex, postClick = false){
    // Find all SET SVG elements and add indicators to matching ones
    const setWrapper = document.querySelector('.set__wrapper');
    if (setWrapper) {
      const allSetSvgs = setWrapper.querySelectorAll('.set__svg');
      // Update the first available SET SVG with this variant's data
      if (allSetSvgs[colorIndex]) {
        const setSvg = allSetSvgs[colorIndex];
        if(postClick){
          if (setSvg) {
            addStellaAiIndicators(setSvg);
          }
        } else {
          if (setSvg && setSvg.getAttribute('data-variant-id') == variantId) {
            addStellaAiIndicators(setSvg);
          }
        }
      }
    }
}

// Helper function to show loading spinner using template
function showLoadingSpinner(container) {
  const loadingTemplate = document.querySelector("#stella-ai-loading-template");
  if (!loadingTemplate) {
    console.warn("❌ Loading template not found");
    return;
  }

  const loadingContainer = loadingTemplate.content;
  const loadingElement = document.importNode(loadingContainer, true);

  container.appendChild(loadingElement);

  const spinnerContainer = container.querySelector(".stella__loading--container");
  if (spinnerContainer) {
    spinnerContainer.classList.add("is-active");
  }
}

// Helper function to show results
function showStellaResults(container, template) {
  const oldResults = container.querySelector('.stella__iframe');
  const loadingContainer = container.querySelector('.stella__loading--container');

  if (oldResults) oldResults.classList.add('hidden');
  if (loadingContainer) loadingContainer.remove();

  container.appendChild(template);

  // Add event listener for the footer button to apply recommendations
  const footerButton = container.querySelector('.stella__ai--results--footer .Button');
  if (footerButton) {
    footerButton.addEventListener('click', handleApplyRecommendations);
  }

  const startAnalysisAgainLink = container.querySelector('.stella-ai--results--start-analysis-again');
  if (startAnalysisAgainLink) {
    startAnalysisAgainLink.addEventListener('click', handleStartAnalysisAgain);
  }
}

// Function to handle applying recommendations when footer button is clicked
function handleApplyRecommendations(event) {
  event.preventDefault();

  // Handle SET swatches first (run setup + click together)
  if (window.stellaSetSwatches && window.stellaSetSwatches.length > 0) {
    window.stellaSetSwatches.forEach(({ swatch, setup, postClick }, index) => {
      setTimeout(() => {
        // Run setup function first
        setup();
        // Then click the swatch
        swatch.click();
        // Finally run post-click function if it exists
        if (postClick) {
          postClick();
        }
      }, index * 20); // Slightly longer delay for SET swatches to ensure setup completes
    });
  }

  // Handle regular swatches (click only)
  if (window.stellaRecommendedSwatches && window.stellaRecommendedSwatches.length > 0) {
    // Start regular swatch clicks after SET swatches (if any)
    const setSwatchDelay = window.stellaSetSwatches ? window.stellaSetSwatches.length * 20 : 0;

    window.stellaRecommendedSwatches.forEach((swatch, index) => {
      setTimeout(() => {
        swatch.click();
      }, setSwatchDelay + (index * 10)); // Start after SET swatches complete
    });
  }

  // Clear all stored arrays after applying
  const totalActions = (window.stellaSetSwatches ? window.stellaSetSwatches.length : 0) +
                      (window.stellaRecommendedSwatches ? window.stellaRecommendedSwatches.length : 0);

  if (totalActions > 0) {
    setTimeout(() => {
      window.stellaRecommendedSwatches = [];
      window.stellaSetSwatches = [];
    }, ((window.stellaSetSwatches ? window.stellaSetSwatches.length * 20 : 0) +
        (window.stellaRecommendedSwatches ? window.stellaRecommendedSwatches.length * 10 : 0) + 100));
  }
}

// Function to handle "start analysis again" click
function handleStartAnalysisAgain(event) {
  event.preventDefault();

  // Hide analysis results but keep data for potential reuse
  // Only clear Stella AI specific data, preserve Findation data
  localStorage.removeItem("stellaRecommendedProductVariants");
  localStorage.removeItem("stellaAnalysesData");
  localStorage.removeItem("stellaAnalysisProductUrl");

  // Update button texts to show main text (no analysis data)
  updateStellaAiButtonTexts(false);

  // Clear stored recommended swatches and SET swatches
  window.stellaRecommendedSwatches = [];
  window.stellaSetSwatches = [];

  cleanupPreviousStellaAiIndicators();

  // Update info text visibility after clearing analysis data
  showStellaAiInfoTextOnDifferentPage();

  const stellaPopupContainer = document.querySelector(".stella__iframe--container .Container");
  if (!stellaPopupContainer) {
    return;
  }

  const modal = stellaPopupContainer.closest('.Modal');

  // Check if there's a findation popup element inside the modal
  const findationPopupElement = modal ? modal.querySelector('.findation__content') : null;

  // Check if this is a findation popup - preserve findation functionality
  // Use the presence of findation popup element OR the modal class as indicators
  if (modal && (modal.classList.contains('findation__popup') || findationPopupElement)) {
    // Use helper function to restart analysis while keeping findation available
    restartAnalysisKeepingFindation(stellaPopupContainer);
  } else {
    // For regular Stella AI popup, replace content normally
    const iframeTemplate = document.querySelector("#stella-ai-iframe-template");
    if (!iframeTemplate) {
      return;
    }

    const iframeContainer = iframeTemplate.content;
    const iframeElement = document.importNode(iframeContainer, true);

    stellaPopupContainer.innerHTML = '';
    stellaPopupContainer.appendChild(iframeElement);
  }
}

// Helper function to restart analysis while preserving findation
function restartAnalysisKeepingFindation(stellaPopupContainer) {
  const modal = stellaPopupContainer.closest('.Modal');

  // Remove any existing results
  const resultsContainer = stellaPopupContainer.querySelector('.stella__ai--results--container');
  if (resultsContainer) {
    resultsContainer.remove();
  }

  // Reset the Stella AI iframe for new analysis
  const stellaIframe = stellaPopupContainer.querySelector('.stella__iframe');
  const iframeTemplate = document.querySelector("#stella-ai-iframe-template");

  if (iframeTemplate && stellaIframe) {
    const iframeContainer = iframeTemplate.content;
    const iframeElement = document.importNode(iframeContainer, true);

    // Get the stella analysis element from template
    const stellaAnalysisElement = iframeElement.querySelector('stella-analysis');
    if (stellaAnalysisElement) {
      stellaIframe.innerHTML = '';
      stellaIframe.appendChild(stellaAnalysisElement);
    }

    // Show the iframe since we're starting new analysis
    stellaIframe.classList.remove('hidden');
  }

  // Keep findation available but hidden
  const findationPopup = modal.querySelector('.findation__content');
  if (findationPopup) {
    findationPopup.classList.add('hidden');
  }

  const findationStellaBtn = document.querySelector('.button--stella-ai');
  if(findationStellaBtn){
    findationStellaBtn.innerHTML = findationStellaBtn.getAttribute('data-default-text');
  }

  // Ensure modal doesn't have findation popup class while doing stella analysis
  modal.classList.remove('findation__popup');
}

// Helper function to remove cart item
async function removeCartItem(itemKey) {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: 0
      })
    });

    if (!response.ok) {
      throw new Error(`Failed to remove item: ${response.statusText}`);
    }

    return response.json();
  } catch (error) {
    console.error('Error removing cart item:', error);
    throw error;
  }
}

// Function to show Stella AI info text when on different product page
function showStellaAiInfoTextOnDifferentPage() {
  const analysisData = localStorage.getItem("stellaRecommendedProductVariants");
  const userAnalysisData = localStorage.getItem("stellaAnalysesData");
  const analysisProductUrl = localStorage.getItem("stellaAnalysisProductUrl");
  const infoTextElements = document.querySelectorAll('.stella__ai--info-text');

  // Check if we have analysis data and we're on a different product page
  if (analysisData && userAnalysisData && analysisProductUrl &&
      window.location.pathname !== analysisProductUrl) {

    // Show all stella__ai--info-text elements
    infoTextElements.forEach(element => {
      element.classList.remove('hidden');
    });
  } else {
    // Hide info text elements if no analysis data or on same product page
    infoTextElements.forEach(element => {
      element.classList.add('hidden');
    });
  }
}

// Add DOMContentLoaded listener to check and show info text on page load
document.addEventListener('DOMContentLoaded', showStellaAiInfoTextOnDifferentPage);

window.showIngredients = function () {
  try {
    // Collect active variants from sets / multiproducts
    const activeVariants = document.querySelectorAll(
      '.Product__Wrapper .ColorSwatch__Radio:checked, .Product__Wrapper .is-active-color .set__svg.is-active, .Product__Wrapper select[name="id"] option[selected], .free-gift-swatch-active'
    );

    const variantIds = Array.from(activeVariants)
      .map(item => {
        const raw = item.getAttribute('data-variant-id') ||  item.getAttribute('data-mono-variant-id') || item.value;
        const id = Number(raw);
        return Number.isFinite(id) ? id : null;
      })
      .filter(Boolean);

    if (variantIds.length) {
      // Hide all tab contents
      document.querySelectorAll('.ProductIngredients ').forEach(el => {
        el.style.display = 'none';
      });

      // Show only the relevant tab contents
      variantIds.forEach(variantId => {
        const target = document.querySelectorAll('.ingredients-' + CSS.escape(String(variantId))).forEach(el => {
            el.style.display = 'block';
          });
      });

    }

  } catch (e) {
    console.error('[Ingredients DEBUG] error:', e);
  }
};

// Show ingredients when page finishes loading
document.addEventListener('DOMContentLoaded', showIngredients);

// Stella AI Modal Handler
(function() {
  // Cache DOM elements and selectors
  const SELECTORS = {
    modal: '.stella__iframe--container.Modal',
    iframe: '.stella__iframe--container .stella__iframe',
    findationPopup: '.stella__iframe--container .findation__content'
  };

  const CLASSES = {
    findationPopup: 'findation__popup',
    hidden: 'hidden'
  };

  // Get modal elements with caching
  function getModalElements() {
    return {
      modal: document.querySelector(SELECTORS.modal),
      iframe: document.querySelector(SELECTORS.iframe),
      findationPopup: document.querySelector(SELECTORS.findationPopup)
    };
  }

  // Switch to Stella AI interface
  function switchToStellaAI(elements) {
    const { modal, iframe, findationPopup } = elements;
    const stellaAiResultsContainer = modal.querySelector('.stella__ai--results--container');

    modal.classList.remove(CLASSES.findationPopup);

    // Show iframe only if there are no existing results
    // This allows users to restart analysis while keeping findation available
    if(!stellaAiResultsContainer) {
      iframe.classList.remove(CLASSES.hidden);
    }

    // Hide findation popup but don't destroy it
    findationPopup.classList.add(CLASSES.hidden);
  }

  // Reset to findation popup state
  function resetToFindation(elements) {
    const { modal, iframe, findationPopup } = elements;

    modal.classList.add(CLASSES.findationPopup);
    iframe.classList.add(CLASSES.hidden);
    findationPopup.classList.remove(CLASSES.hidden);
  }


  // Main event handler
  function handleModalInteraction(event) {
    const { target } = event;

    // Handle Stella AI button click (switch to Stella interface)
    if (target.classList.contains('button--stella-ai')) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const elements = getModalElements();
      if (!elements.modal || !elements.iframe || !elements.findationPopup) {
        console.error('Stella AI modal elements not found');
        return;
      }

      switchToStellaAI(elements);
      return;
    }

    // Handle modal open button click (reset to findation state)
    if (target.classList.contains('stella__ai--button')) {
      const modalId = target.getAttribute('aria-controls');
      if (modalId && modalId.includes('stella')) {
        const elements = getModalElements();
        if (elements.modal && elements.iframe && elements.findationPopup) {
          resetToFindation(elements);
        }
      }
    }
  }

  function handleFindationInteraction(event) {
    const { target } = event;
    // Handle modal open button click (reset to findation state)
    if (target.classList.contains('button--findation')) {
      if(Findation)
        Findation.openWidget();
      }
  }


  // Initialize event listener
  document.addEventListener('click', handleModalInteraction, true);
  document.addEventListener('click', handleFindationInteraction);
})();